import React, { useState, useRef, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../store/UserMaintanence";
import { searchEmployees } from "../../store/employeeSlice";

const AddUser = ({ open, onClose, initData }) => {
    const dispatch = useDispatch();
    const debounceRef = useRef(null);
    const [form, setForm] = useState({
        taggedUser: null,
        supervisor: null,
    });
    const { employeeOptions, loading: employeeLoading } = useSelector(
        (state) => state.employees
    );
    const handleEmployeeSearch = (value) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            if (value.length < 2) return;
            dispatch(searchEmployees(value));
        }, 300);
    };

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);

    const handleSubmit = () => {
        const user = form.taggedUser;
        const supervisor = form.supervisor;
        if (!user) {
            console.log("Please select a user");
            return;
        }
        if (!supervisor) {
            console.log("Please select a supervisor");
            return;
        }
        const isDuplicate = initData?.some(
            (item) => item.Enterprise_ID === user.eid
        );
        if (isDuplicate) {
            console.log("Duplicate user exists");
            return;
        }
        dispatch(addUser(user.eid, supervisor.eid));
        setForm({
            taggedUser: null,
            supervisor: null,
        });
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { width: "450px", maxWidth: "450px", borderTop: "2px solid #A100FF", borderRadius: "0px !important" } }}
        >
            <Typography
                sx={{
                    padding: "10px 20px",
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#000000",
                    backgroundColor: "#F1F1EF"
                }}
            >
                Add User
            </Typography>
            <DialogContent
                sx={{
                    padding: "10px 20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    marginBottom: "10px",
                }}
            >
                <div>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#000000",
                            marginBottom: "8px",
                        }}
                    >
                        Enter Enterprise ID{" "}
                        <span style={{ color: "#A80011" }}>*</span>
                    </Typography>

                    <Autocomplete
                        options={employeeOptions}
                        loading={employeeLoading}
                        noOptionsText="No employees found"
                        filterOptions={(x) => x}
                        getOptionLabel={(option) => option?.eid || ""}
                        onInputChange={(event, value, reason) => {
                            if (reason === "input") {
                                handleEmployeeSearch(value);
                            }
                        }}
                        value={form.taggedUser}
                        onChange={(event, newValue) => {
                            setForm((prev) => ({
                                ...prev,
                                taggedUser: newValue,
                            }));
                        }}
                        popupIcon={
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    "/images/Home/sort-arrow.svg"
                                }
                                alt="dropdown"
                                style={{ width: 16, height: 16 }}
                            />
                        }
                        forcePopupIcon={true}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Type EID"
                                size="small"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        height: 38,
                                        borderRadius: 0,
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "6px 10px",
                                        marginTop: "-5px",
                                    },
                                    "& .MuiAutocomplete-tag": {
                                        maxWidth: "100px",
                                    },
                                    "& .MuiAutocomplete-inputRoot": {
                                        flexWrap: "nowrap",
                                        overflowX: "auto",
                                        overflowY: "hidden",
                                    },
                                }}
                            />
                        )}
                    />
                </div>

                <div>
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#000000",
                            marginBottom: "8px",
                        }}
                    >
                        Enter Supervisor ID{" "}
                        <span style={{ color: "#A80011" }}>*</span>
                    </Typography>

                    <Autocomplete
                        options={employeeOptions}
                        loading={employeeLoading}
                        filterOptions={(x) => x}
                        getOptionLabel={(option) => option?.eid || ""}
                        onInputChange={(event, value, reason) => {
                            if (reason === "input") {
                                handleEmployeeSearch(value);
                            }
                        }}
                        value={form.supervisor}
                        onChange={(event, newValue) => {
                            setForm((prev) => ({
                                ...prev,
                                supervisor: newValue,
                            }));
                        }}
                        popupIcon={
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    "/images/Home/sort-arrow.svg"
                                }
                                alt="dropdown"
                                style={{ width: 16, height: 16 }}
                            />
                        }
                        forcePopupIcon={true}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Supervisor"
                                size="small"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        height: 38,
                                        borderRadius: 0,
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "6px 10px",
                                        marginTop: "-5px",
                                    },
                                }}
                            />
                        )}
                    />
                </div>
            </DialogContent>

            <DialogActions sx={{ padding: "10px 20px", backgroundColor: "#F1F1EF" }}>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        backgroundColor: "#F1F1EF",
                        border: "1px solid #CFCFCF",
                        padding: "5px 30px",
                        color: "#000000",
                        borderRadius: 0,
                        height: "30px",
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{
                        backgroundColor: "#000000",
                        border: "1px solid #000000",
                        padding: "5px 30px",
                        color: "#fff",
                        borderRadius: 0,
                        height: "30px",
                        "&:hover": { backgroundColor: "#000000" },
                    }}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddUser;